import cx from 'classnames';
import CrossIcon from '../icons/CrossIcon';
import MenuIcon from '../icons/MenuIcon';

type MenuButtonProps = {
  isOpen: boolean;
  className?: string;
};

const MenuButton = ({ isOpen, className = '' }: MenuButtonProps) => {
  const iconClasses = cx('h-6 w-6', className);
  if (isOpen) {
    return <CrossIcon className={iconClasses} />;
  }
  return <MenuIcon className={iconClasses} />;
};

export default MenuButton;
